import { DataStub } from '@tencent/data-schema-core';
import { joinPath, splitPath } from '@tencent/data-schema-core/lib/utils/path';
/**
 * 打扁 DataSchema
 *
 * 提取一个 DataSchema 下面的全部字段，把所有深层的字段全提取出来
 */
export function flattenDataSchema(schema, basePath = '') {
  const ans = [];
  const rootStub = new DataStub({
    schema
  });
  const queue = [{
    stub: rootStub,
    path: basePath
  }];
  const basePathParts = splitPath(basePath);
  while (queue.length) {
    var _stub$definedFields;
    const cur = queue.shift();
    if (!cur) continue;
    const {
      path,
      stub
    } = cur;
    const schema = stub === null || stub === void 0 ? void 0 : stub.schema;
    if (!schema) continue;
    const id = schema.id || '';
    (_stub$definedFields = stub.definedFields) === null || _stub$definedFields === void 0 || _stub$definedFields.forEach(subSchema => {
      const subStub = stub.getChildStub(subSchema.id);
      if (!subStub) return;
      const subPath = joinPath([...basePathParts, ...subStub.pathParts]);
      queue.push({
        path: subPath,
        stub: subStub
      });
    });
    // 遍历到一个节点
    const name = schema.title || id;
    ans.push({
      id,
      name,
      path,
      schema,
      searchKeywords: `${name}\n${path}\n${schema.description || ''}`.toLowerCase()
    });
  }
  return ans;
}
/**
 * 在打扁 DataSchema 的结果里搜索，返回用于 DSTree 展示的 fieldFilter
 *
 * @param matcher 搜索关键词，或者一个匹配函数
 */
export function searchInDataSchema(fields, matcher) {
  const ans = {};
  let matFn;
  if (typeof matcher === 'function') matFn = matcher;else {
    const keyLowerCase = matcher.toLowerCase();
    matFn = x => x.searchKeywords.includes(keyLowerCase);
  }
  fields.forEach(item => {
    if (!matFn(item)) return;
    const p = splitPath(item.path);
    while (p.length) {
      ans[joinPath(p)] = true;
      p.pop();
    }
  });
  return ans;
}